import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import {kSystemDontKnowOption} from "../../../constants/objects";
import NeoFlashQuestionOptionItem from "../../items/flashScreen/NeoFlashQuestionOptionItem";

export default function NeoFlashQuestionOptionsList({ options,
                                                   optionSelected,
                                                   setOptionSelected,
                                                   onDontKnowPress }) {
    // Used in FlashQuestionContent to display list of question
    // options and a default DontKnow option

    // BUILD
    if (isArrayNullUndefinedOrEmpty(options))
        return null
    return (
        <div className={"w-2/5 h-[360px] min-h-[360px] flex flex-col space-y-[24px]"}>
            {/** OPTIONS */}
            {options?.map((option, index) => (
                <NeoFlashQuestionOptionItem key={index}
                                            isLast={false}
                                            option={option}
                                            optionSelected={optionSelected}
                                            setOptionSelected={setOptionSelected}
                                            onDontKnowPress={onDontKnowPress} />
            ))}
            {/** DONT KNOW ITEM */}
            <NeoFlashQuestionOptionItem isLast={true}
                                        option={kSystemDontKnowOption}
                                        optionSelected={optionSelected}
                                        setOptionSelected={setOptionSelected}
                                        onDontKnowPress={onDontKnowPress} />
        </div>
    );
}